module.exports = __webpack_public_path__ + "media/components/rooms/preview_room_hero_bg-9dad6086e2709b038eae582a845b64d9.jpg";